import { Box, ButtonBase, Typography } from "@material-ui/core";
import React, { FC } from "react";
import { useHistory, useParams } from "react-router-dom";

import { CustomButton } from "@/components/Button";
import { Chevron } from "@/components/Chevron";
import {
  LearningFailure,
  LearningStageCard,
  LearningStageContent,
  useLearningLayout,
} from "@/components/learning/LearningStageContent";
import { Loading } from "@/components/Loading";
import { LEARNING_STAGES, findStageById } from "@/constants/learning";
import { useDevice } from "@/hooks/useDevice";
import { useLearningProgress } from "@/hooks/useLearningProgress";
import { BaseTemplate } from "@/layouts/BaseTemplate";

export const LearningStagePage: FC = () => {
  const classes = useLearningLayout();
  const history = useHistory();
  const { isMobile } = useDevice();
  const { stageId } = useParams<{ stageId: string }>();
  const { statusMap, loading, initialized, error, refetch } = useLearningProgress();
  const stage = findStageById(stageId);
  const handleBack = () => history.replace("/learning");
  return (
    <BaseTemplate
      isDense
      isPcV2
      isBackGroundWhite={isMobile}
      headerTitle={isMobile ? (stage?.label ?? "学ぶ") : undefined}
      onBack={isMobile ? handleBack : undefined}
    >
      <Box className={classes.page}>
        {!isMobile && (
          <Box className={classes.head}>
            <ButtonBase className={classes.back} onClick={handleBack}>
              <Chevron direction="back" />
              不動産投資を学ぶ
            </ButtonBase>
            <Typography component="h1" className={classes.title}>
              {stage?.title ?? "学ぶ"}
            </Typography>
          </Box>
        )}
        {!stage ? (
          <Box className={classes.state}>
            <Typography>指定された学習ステージが見つかりません。</Typography>
            <CustomButton onClick={handleBack}>学習トップへ戻る</CustomButton>
          </Box>
        ) : loading || !initialized ? (
          <Loading />
        ) : error ? (
          <LearningFailure error={error} onRetry={refetch} />
        ) : (
          <Box className={classes.columns}>
            {!isMobile && (
              <Box className={classes.cards}>
                {LEARNING_STAGES.map((item) => (
                  <LearningStageCard
                    key={item.id}
                    {...item}
                    selected={item.id === stage.id}
                    total={item.articles.length}
                    completed={item.articles.filter((article) => statusMap[article.id]).length}
                    onClick={() => history.push(`/learning/${item.id}`)}
                  />
                ))}
              </Box>
            )}
            <LearningStageContent
              stage={stage}
              statusMap={statusMap}
              onOpenArticle={(article) =>
                history.push({ pathname: `/learning/articles/${article.id}`, state: { fromStage: stage.id } })
              }
              onNextStage={(next) => history.push(`/learning/${next.id}`)}
            />
          </Box>
        )}
      </Box>
    </BaseTemplate>
  );
};
